<template>
    <div>
        <form @submit.prevent="submitFormData">
            <div v-if="!isEdit" class="form-group d-flex">
                <div class="input-group-prepend w-100">
                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                        <i class="fas fa-store"></i>
                    </label>
                    <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                    </multiselect>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 border-right p-3">
                     <div class="form-group">
                        <label class="form-label">{{$t('label.shop_name')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-store-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.shop_name')" v-model="companyName">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.location')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-map-marker-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.location')" v-model="location">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.city')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0 bg-transparent">
                                    <i class="fas fa-map-marker-alt"></i>
                                </label>
                                <multiselect  
                                    v-model="selectedCity" 
                                    :options="cities" 
                                    group-values="city" group-label="state" 
                                    track-by="cityID" label="city" 
                                    :show-labels="false" 
                                    openDirection="below" 
                                    @select="selectCity">
                                    <span slot="noResult">{{$t('table.no_records')}}</span>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.details')}}</label>
                        <textarea class="form-control" :placeholder="$t('label.details')" rows="5" v-model="companyDetails"></textarea>
                    </div>
                    <div class="form-group mb-1">
                        <label class="form-label">{{$t('label.contact')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-phone-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact" @keyup="contactValidation">
                        </div>
                        <div id="err" class="error-validation"></div>
                    </div>
                    <div class="help-block fs-xs">
                        <p class="mb-0">{{$t('message.contact_validation.notes')}}:</p>
                        <ul>
                            <li>{{$t('message.contact_validation.my')}} 601x xxx xxxx</li>
                            <li>{{$t('message.contact_validation.sg')}} 65x xxx xxxx</li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 p-5">
                    <h6 class="text-dark fw-500">{{$t('header.tukang_shop')}} {{$t('label.image')}}:</h6>
                    <div class="card-columns">
                        <div v-for="item in gallery" :key="item.id" class="card">
                            <div v-if="item.src != ''">
                                <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end">
                                    <div class="text-primary">
                                        <a class="link mr-2" @click="showUploadImage(item)">
                                            <i class="fal fa-cog"></i>
                                        </a>
                                        <a class="link" @click="showDeleteImage(item)">
                                            <i class="fal fa-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <img class="border-top-left-radius-0 border-top-right-radius-0 card-img-top" :src="getImage(item.src)"/>
                            </div>
                            <div v-else>
                                <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end" style="height: 2.5em;"></div>
                                <div class="pt-5 pb-5 card-body d-flex align-items-center justify-content-center">
                                    <a class="link" title="Add Image" @click="showUploadImage(item)">
                                        <div class='icon-stack display-3'>
                                            <i class="fas fa-image-polaroid icon-stack-3x opacity-50 color-fusion-500" ></i>
                                            <i class="fas fa-plus-circle icon-stack-1x opacity-100 color-fusion-300"></i>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="border-top text-left pt-3 mt-3 mb-3">
                <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnShopList">{{$t('button_link.cancel')}}</button>
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
            </div>
        </form>
        <div :class="{'show': uploadToggle }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 d-flex align-items-center"><i class="fas fa-cloud-upload-alt mr-3"></i>{{$t('header.upload_image')}}</h5>
                        <button type="button" class="close" @click="uploadToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pt-3">
                        <div v-if="selectedImage.src != ''">
                            <h6 class="fw-500">{{$t('label.selected_image')}}: </h6>
                            <img class="img-item mb-3" :src="getImage(selectedImage.src)"/>
                        </div>
                        <vue-dropzone :id="selectedImage.id" ref="dropzone" class="text-center" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>
<script>
import _ from 'lodash';
import DeleteModal from './../../Delete_Modal'
import vueDropzone from "vue2-dropzone";
import {handleSessionExpired, getCityList} from '@/assets/js/dashboard/dashboard.js'
import {contactValidation} from '@/assets/js/dashboard/utilities.js'
export default {
    name: "tukangShopForm",
    components:{
        vueDropzone, 
        DeleteModal
    },
    data(){
        return{
            outlet: [], selectedOutlet: {},
            companyName: "", contact: "", location: "", cities: [], selectedCity: {}, companyDetails: "",
            cityList: [], gallery: [], uploadToggle: false, selectedImage: {},
            isDropzoneShow: false, deleteToggleModal: false,
            isEdit: false,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            }
        }
    },
    methods:{
        getImage(img){
            return img
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.presetForm()
        },  
        async presetForm(){
            var result = await this.getInfo();
            this.companyName = this.selectedOutlet.bizName
            this.location = result.location
            this.contact = result.contact
            var state = this.cityList.filter(obj=> obj.cityID == parseInt(result.cityID))[0].state
            var city = this.cities.filter(obj=> obj.state == state)[0]
            this.selectedCity = city.city.filter(o=> o.cityID == parseInt(result.cityID))[0]
        },
        async getInfo(){
            let $vm = this;
            const url = $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.INFO

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data;  
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            }) 
            return result
        }, 
        closeModal(isError){
            if(!isError){
                if(this.uploadToggle || this.$refs.deleteModal.toggleModal){
                    this.uploadToggle = false
                    this.$refs.deleteModal.toggleModal = false
                    this.resetImage()
                }else{
                    this.returnShopList()
                    this.$store.commit('RESET_TUKANG_IMAGE', 'shop');
                } 
            }
            this.$parent.$parent.$parent.isModalShow = false;
        },
        resetImage(){
            var image = this.$store.state.stateTukangShopImage.filter(i=> i.imageID === this.selectedImage.id)
            const found = this.gallery.some(o=> o.id == this.selectedImage.id)
            if(found){
                this.gallery = this.gallery.filter(j=> j.id !== this.selectedImage.id)
            }
            this.gallery.push({
                index: parseInt(image[0].imageID.substr(image[0].imageID.length - 1)),
                id: image[0].imageID,
                src: image[0].path,
                thumbnail: image[0].path
            })

            this.gallery.sort((a,b)=> a.index - b.index);
        },
        contactValidation(){
            var err = contactValidation(this.contact);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        selectCity(item){
            this.selectedCity = item
        },
        returnShopList(){
            this.$emit('returnShopList');
        },
        editTukangShopForm(data){
            this.isEdit = true
            
            this.companyName = data.TkCompanyName
            this.location = data.TkCompanyLocation
            this.companyDetails = data.TkCompanyDetails
            this.contact = data.TkCompanyMobile
            this.gallery = data.TkCompanyImage

            for(var i=1; i<=6; i++){
                var key = "TkCompanyImage" + i;
                if(!(this.gallery.some(el => el.id === key))){
                    this.gallery.push({
                        index: i,
                        id: key,
                        src: "",
                        thumbnail: ""
                    })
                }
            }

            this.selectedCity = {cityID: parseInt(data.TkCompanyCityID), city: this.getCityName(data.TkCompanyCityID)}
        },
        showDeleteImage(item){
            this.selectedImage = item
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage(){
            var obj = {
                imageID: this.selectedImage.id,
                path: ""
            }
            this.$store.commit('SET_TUKANG_SHOP_IMAGE', obj);

            var data = {}
            data[this.selectedImage.id] = ""
            this.submitTukangShop(data, false, true)
        },
        async getCity(){
            this.cityList = await getCityList(this);
            var group = _.groupBy(this.cityList, 'stateID');
            for(var id in group){
                var data = {}
                data["state"] = group[id][0].state
                var cityArr = []
                for(var i=0; i<group[id].length; i++){
                    cityArr.push({
                        cityID: group[id][i].cityID,
                        city: group[id][i].city,
                    })
                }
                data["city"] = cityArr;
                this.cities.push(data)
            }
            this.selectedCity = this.cities[0].city[0]
        },
        getCityName(id){
            var city = ""
            for(var i=0; i<this.cityList .length; i++){
                if(parseInt(id) == this.cityList[i].cityID){
                    city = this.cityList[i].city
                    break
                }
            }
            return city
        },
        showUploadImage(item){
            this.selectedImage = item
            this.uploadToggle = true
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }else{
                this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.upload'));

                var obj = {
                    imageID: this.selectedImage.id,
                    path: response.path
                }
                this.$store.commit('SET_TUKANG_SHOP_IMAGE', obj);
            }
            
            // var data = this.setFormData()
            // data[this.selectedImage.id] = response.path
            // this.submitTukangShop(data, false, false)
            this.$refs.dropzone.removeFile(file)
        },
        submitFormData(){
            var data = this.setFormData()
            var stateImage = this.$store.state.stateTukangShopImage
            for(var i=0; i<stateImage.length; i++){
                data[stateImage[i].imageID] = stateImage[i].path
            }
            this.submitTukangShop(data, true, false)
        },
        setFormData(){
            var data = {
                TkCompanyName: this.companyName,
                TkCompanyDetails: this.companyDetails,
                TkCompanyMobile: this.contact,
                TkCompanyLocation: this.location,
                TkCompanyCityID: this.selectedCity.cityID.toString(),
            }
            return data
        },
        submitTukangShop(data, isFormData, isDeleteImage){
            let $vm = this;
            let QUERY_STRING = this.isEdit ? this.$api.UPDATE  : "";
            const url =  this.$api.TUKANG_SHOP + QUERY_STRING;

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var message = isFormData ? $vm.$i18n.t('header.tukang_shop') + $vm.$i18n.t('message.success.success', {'action': $vm.isEdit ? $vm.$i18n.t('message.success.action.update') : $vm.$i18n.t('message.success.action.add')}) :isDeleteImage ? $vm.$i18n.t('message.success.delete_image'): $vm.$i18n.t('message.success.upload')
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        }
    },
    async mounted(){
        let $vm = this
        $vm.getCity()

        for(var j=1; j<=6; j++){
            var key = "TkCompanyImage" + j
            $vm.gallery.push({
                id: key,
                src: "",
                thumbnail: "",
            })
        }

        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];

        if(!$vm.isEdit){
            await $vm.presetForm();  
        }
        
    },
}
</script>
<style scoped>
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
.link{
    cursor: pointer;
}
.card-columns{
    column-count: 2 !important;
    column-gap: 1em;
}
.card-header{
    background: #F2F0F7;
}
.show{
    display: block;
}
.img-item{
    width: 15em;
}
.icon-stack-1x{
    top: 30%;
    left: 50%;
    font-size: .35em;
}
</style>